export const customerLogInMutation = /* GraphQL */ `
  mutation customerLogIn($email: String!, $password: String!) {
    customerSignMeIn(draft: { email: $email, password: $password }) {
      customer {
        id
      }
    }
  }
`
